import React, { useState } from 'react';
import { Popover, Button, Menu } from 'antd';
import PropTypes from 'prop-types';
import { MoreOutlined } from '@ant-design/icons';
import { getUniqueId } from '../../helpers/helper.functions';
import './index.scss';

const AppPopOverMenu = (props) => {
    const { options = [], icon = <MoreOutlined rotate={90} /> } = props;
    const [open, setOpen] = useState(false);
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    /**
     * Invokes when the popover is closed
     */
    const handleCloseMenu = () => {
        setOpen(false);
    };

    const menu = (
        <Menu>
            {options.map((option) => <Menu.Item key={`${getUniqueId()}-${option.label}`} onClick={() => {
                if (typeof option.onClick === "function") {
                    option.onClick()
                }
                handleCloseMenu();
            }}>{option.label}</Menu.Item>
            )}
        </Menu>
    );


    return (
        <>
            <Popover
                content={menu}
                open={open}
                onOpenChange={handleOpenChange}
                placement="topRight"
                trigger="click" {...props}>
                <Button type="text" style={{fontSize: '20px'}} icon={icon}/>
                
            </Popover>
        </>
    )
}
AppPopOverMenu.propTypes = {
    icon: PropTypes.any,
    options: PropTypes.array,
}

export default AppPopOverMenu;